// import { createI18n } from 'vue-i18n'
import { Locale } from 'vant'
// 引入en -us语言包
import enUS from 'vant/lib/locale/lang/en-US';
// 引入zh-CN语言包
import zhCN from 'vant/lib/locale/lang/zh-CN';
const locale = {
  'en-US': enUS,
  'zh-CN': zhCN
}
const localeType = {
  'cn': 'zh-CN',
  'en': 'en-US'
}

export const vantUse = (lang: string) => {
  const langKey = localeType[lang as keyof typeof localeType] || 'en-US'
  
  Locale.use(langKey, locale[langKey as keyof typeof locale])
}
// import messages from './langs'
// const language = ['zh-CN', 'en']
// const locale: any = messages
// const lang: string = language.includes(navigator.language) ? navigator.language : 'en'
// const i18n = createI18n({
//   globalInjection: true,
//   locale: lang,
//   messages: locale
// })
// Locale.use(lang, locale[lang])
// export default i18n
